import { Timeline } from 'antd';
import ITimeLine from '../entities/ITimeLineProps';

const BCTimeLine = (props: ITimeLine) => {
	const { mode, reverse, pendingDot, pending, items, className } = props;

	return (
		<Timeline
			mode={mode}
			reverse={reverse}
			pendingDot={pendingDot}
			pending={pending}
			items={items}
			className={className}
		/>
	);
};
export default BCTimeLine;
export { ITimeLine };
